import * as yup from 'yup';



//Add custom validation method, this code is inspired by Magento's AccountManagement->makeRequiredCharactersCheck
yup.addMethod(yup.string, "magentoPasswordPolicy", function (errorMessage,requiredClassNumber) {
    return this.test(`magentoPasswordPolicy`, errorMessage, function (value) {
      const { path, createError } = this;

      if(!value)
      return true;

      let counter= 0 ;
      
      if(value.match(/[0-9]+/))
        counter++;

      if(value.match(/[A-Z]+/))
        counter++;
    
      if(value.match(/[a-z]+/))
        counter++;

      if(value.match(/[^a-zA-Z0-9]+/))
        counter++;


      if(counter<requiredClassNumber)
        return createError({ path, message: errorMessage });
      else
        return true;
    });
  });



  yup.addMethod(yup.string, "iban", function (errorMessage) {
    return this.test(`iban`, errorMessage, function (value) {
      const { path, createError } = this;

      if(!value)
      return true;

      

      if(!isValidIBANNumber(value)) 
        return createError({ path, message: errorMessage });
      else
        return true;


    });
  });

  yup.addMethod(yup.string, "only_positive", function (errorMessage) {
    return this.test(`only_positive`, errorMessage, function (value) {
      const { path, createError } = this;

      if(!value)
      return true;
      
      

      if(isNaN(value) || parseFloat(value)<0)
        return createError({ path, message: errorMessage });
      else
        return true;


    });
  });

  yup.addMethod(yup.string, "min_value", function (errorMessage, min_value) {
    return this.test(`min_value`, errorMessage, function (value) {
      const { path, createError } = this;

      if(!value)
      return true;
      
      

      if(isNaN(value) || parseFloat(value)<min_value)
        return createError({ path, message: errorMessage });
      else
        return true;


    });
  });

  yup.addMethod(yup.string, "max_value", function (errorMessage, max_value) {
    return this.test(`max_value`, errorMessage, function (value) {
      const { path, createError } = this;

      if(!value)
      return true;
      
      

      if(isNaN(value) || parseFloat(value)>max_value)
        return createError({ path, message: errorMessage });
      else
        return true;


    });
  });



  yup.addMethod(yup.string, "codice_fiscale", function (errorMessage, max_value) {
    return this.test(`codice_fiscale`, errorMessage, function (value) {
    //  const { path, createError } = this;

      if(!value)
      return true;
      
      

      return value.match(/^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i);


    });
  });
/*
  yup.addMethod(yup.string, "vatogo_url", function (errorMessage, max_value) {
    return this.test(`vatogo_url`, errorMessage, function (value) {
      const { path, createError } = this;

      if(!value)
      return true;
      
      

      return value.match(/^((https?|ftp):\/\/)?(www.)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i);


    });
  });
*/

  yup.addMethod(yup.string, "phone_number", function (errorMessage, max_value) {
    return this.test(`phone_number`, errorMessage, function (value) {
    //  const { path, createError } = this;

      if(!value)
      return true;
      
      

      return value.match(/^\+?[1-9]\d{9,14}$/);


    });
  });




  function isValidIBANNumber(input) {
    var CODE_LENGTHS = {
        AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
        CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
        FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
        HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
        LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
        MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
        RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26,   
        AL: 28, BY: 28, CX: 22, EG: 29, GE: 22, IQ: 23, LC: 32, SC: 31, ST: 25,
        SV: 28, TL: 23, UA: 29, VA: 22, VG: 24, XK: 20
    };
    var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
            code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
            digits;
    // check syntax and length
    if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
        return false;
    }
    // rearrange country code and check digits, and convert chars to ints
    digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
        return letter.charCodeAt(0) - 55;
    });
    // final check
    return mod97(digits);
}

function mod97(string) {
    var checksum = string.slice(0, 2), fragment;
    for (var offset = 2; offset < string.length; offset += 7) {
        fragment = String(checksum) + string.substring(offset, offset + 7);
        checksum = parseInt(fragment, 10) % 97;
    }
    return checksum;
}